import { render } from "./TableImages.vue?vue&type=template&id=0e743c90&ts=true"
import script from "./TableImages.vue?vue&type=script&lang=ts"
export * from "./TableImages.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__